(function () {
  document.querySelectorAll('[data-features-row]').forEach(function (root) {
    var track = root.querySelector('[data-features-row-track]');
    var cards = root.querySelectorAll('[data-features-row-card]');
    var nextBtn = root.querySelector('[data-features-row-next]');

    // Scroll-reveal: fade + rise up each card as it enters the viewport
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
      );
      cards.forEach(function (card) {
        observer.observe(card);
      });
    } else {
      cards.forEach(function (card) {
        card.classList.add('is-visible');
      });
    }

    // Arrow button advances one card at a time, looping smoothly back to the start
    if (track && nextBtn) {
      nextBtn.addEventListener('click', function () {
        var card = track.querySelector('[data-features-row-card]');
        var amount = card ? card.getBoundingClientRect().width : 300;
        var maxScroll = track.scrollWidth - track.clientWidth;

        if (track.scrollLeft >= maxScroll - 10) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: amount, behavior: 'smooth' });
        }
      });
    }
  });
})();